import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';

const Separator = () => <TableRow><TableCell style={{ height: 1, padding: 0, margin: 0 }} ><div style={{ height: 1 }}></div></TableCell></TableRow>;

export default Separator;